module.exports = __webpack_public_path__ + "img/image164.94638744.jpg";